/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_ReadyInputs */

const th_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พร้อม`)
};

const en_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

const ja_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備完了`)
};

const zh_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`就绪`)
};

const es_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const pt_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const id_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap`)
};

const fr_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt`)
};

const tl_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handa`)
};

const vi_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng`)
};

const ko_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`준비됨`)
};

const de_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit`)
};

const ru_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово`)
};

const tr_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazır`)
};

const it_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const pl_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowe`)
};

const uk_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово`)
};

const hi_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तैयार`)
};

const ar_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاهز`)
};

const ms_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedia`)
};

const bn_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রস্তুত`)
};

const zh_tw2_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`就緒`)
};

const zh_hk2_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`就緒`)
};

const ur_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیار`)
};

const fa_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آماده`)
};

const sw_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tayari`)
};

const nl_video_ready = /** @type {(inputs: Video_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Video_ReadyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_ready = /** @type {((inputs?: Video_ReadyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_ReadyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_ready(inputs)
	if (locale === "ja") return ja_video_ready(inputs)
	if (locale === "zh") return zh_video_ready(inputs)
	if (locale === "es") return es_video_ready(inputs)
	if (locale === "pt") return pt_video_ready(inputs)
	if (locale === "id") return id_video_ready(inputs)
	if (locale === "fr") return fr_video_ready(inputs)
	if (locale === "tl") return tl_video_ready(inputs)
	if (locale === "vi") return vi_video_ready(inputs)
	if (locale === "ko") return ko_video_ready(inputs)
	if (locale === "de") return de_video_ready(inputs)
	if (locale === "ru") return ru_video_ready(inputs)
	if (locale === "tr") return tr_video_ready(inputs)
	if (locale === "it") return it_video_ready(inputs)
	if (locale === "pl") return pl_video_ready(inputs)
	if (locale === "uk") return uk_video_ready(inputs)
	if (locale === "hi") return hi_video_ready(inputs)
	if (locale === "ar") return ar_video_ready(inputs)
	if (locale === "ms") return ms_video_ready(inputs)
	if (locale === "bn") return bn_video_ready(inputs)
	if (locale === "zh-TW") return zh_tw2_video_ready(inputs)
	if (locale === "zh-HK") return zh_hk2_video_ready(inputs)
	if (locale === "ur") return ur_video_ready(inputs)
	if (locale === "fa") return fa_video_ready(inputs)
	if (locale === "sw") return sw_video_ready(inputs)
	if (locale === "nl") return nl_video_ready(inputs)
	return en_video_ready(inputs)
});